export default __webpack_public_path__ + "static/media/hand.cdcc0936.png";